import {fetchBody,  URL_EMPLOYEE_GET_RESUME_OTHERDATA, URL_EMPLOYEE_ADD_RESUME_OTHERDATA, URL_EMPLOYEE_ADD_RESUME, URL_EMPLOYEE_UPDATE_RESUME, URL_EMPLOYEE_GET_RESUME_LIST, URL_EMPLOYEE_GET_RESUME_DETAIL, URL_EMPLOYEE_CHECK_RESUME} from "../config"
import { toLogout, cleanFetch } from "./apiTools";
import { getToken } from "../component/Login/Auth";

//內部員工

export function api_getEmployeeResumeList ({mReqEmployeeResumeList, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqEmployeeResumeList, token}), 
      url: URL_EMPLOYEE_GET_RESUME_LIST, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}

export function api_checkEmployeeResume ({mReqEmployeeResumeCheck, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqEmployeeResumeCheck, token}), 
      url: URL_EMPLOYEE_CHECK_RESUME, 
      success:(jsonDate)=>{
        success(jsonDate)
      },
      failure:(error)=>{
        failure(error)
      }
    })
  }
}
export function api_addEmployeeResume ({mReqEmployeeResumeAdd, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqEmployeeResumeAdd, token}), 
      url: URL_EMPLOYEE_ADD_RESUME, 
      success:(jsonDate)=>{
        success(jsonDate)
        return jsonDate
      },
      failure:(error)=>{
        failure(error)
        return error
      }
    })
  }
}

export function api_getEmployeeResumeDetail ({mReqResumeDetail, success, failure}) {
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqResumeDetail, token}), 
      url: URL_EMPLOYEE_GET_RESUME_DETAIL, 
      success:(jsonDate)=>{
        success(jsonDate)
        return jsonDate
      },
      failure:(error)=>{
        failure(error)
        return error
      }
    })
  }
}

export function api_getEmployeeResumeUpdate({mReqResumeEdit}){
  var token = getToken();
  if(token === ""){
    toLogout(false);
  }else{
    cleanFetch({
      body: fetchBody({body: mReqResumeEdit, token}), 
      url: URL_EMPLOYEE_UPDATE_RESUME, 
      success:(jsonDate)=>{
        return jsonDate
      },
      failure:(error)=>{
        return error
      }
    })
  }
}

